import axios from 'axios'

interface iResExternalSystem {
  url: string,
  napojeniNaEkomunikaci: boolean
}

class FenApi {

  api = axios.create()

  init = (apiUrl?: string) => {
    if (!apiUrl) {
      console.error('Neni API_FEN_URL')
    }
    this.api = axios.create({
      baseURL: apiUrl
    })
  }

  getExternalSystem = () =>
    this.api.get<iResExternalSystem[]>(`/api/externi_systemy`)
      .then(res => res.data)

  getExternalSystemWithEkom = () =>
    this.api.get<iResExternalSystem[]>(`/api/externi_systemy?napojeniNaEkomunikaci=true`)
      .then(res => res.data)

}

export default new FenApi()




